import WorldScene from "@/components/WorldScene";
import { Lock, Check } from "lucide-react";

export default function World({ state }) {
  const owned = new Set(state.unlocks.owned_codes);
  const groups = [
    { title: "Drum unlocks",   kind: "drums",   items: state.unlocks.all.filter((u) => u.type === "drums") },
    { title: "English unlocks", kind: "english", items: state.unlocks.all.filter((u) => u.type === "english") },
    { title: "Perfect weeks",  kind: "perfect", items: state.unlocks.all.filter((u) => u.type === "perfect") },
  ];
  const totalOwned = owned.size;
  return (
    <div className="pb-28 pt-5">
      <header className="text-center lg:text-left">
        <p className="micro-label">Your world</p>
        <h1 className="text-[32px] lg:text-[44px] text-[hsl(var(--ink))] leading-tight">{state.child.name}&apos;s room</h1>
        <p className="mt-1 text-[15px] lg:text-base text-[hsl(var(--ink-soft))]">
          {totalOwned} of {state.unlocks.all.length} items unlocked
        </p>
      </header>

      {/* HERO ROOM — uses the ultimate-empty variant, capped to fit in viewport */}
      <div className="mt-5 lg:mt-8">
        <div className="mx-auto w-full" style={{ maxWidth: "min(100%, 70vh)" }}>
          <WorldScene
            ownedCodes={state.unlocks.owned_codes}
            mascotState="happy"
            mascotSize={120}
            roomImage="/assets/world/bedroom-empty.png"
            testId="world-scene-hero"
            className="w-full"
          />
        </div>
      </div>

      {groups.map((g) => (
        <section key={g.title} className="mt-10">
          <h2 className="text-[20px] lg:text-[24px] text-[hsl(var(--ink))] mb-3">{g.title}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 lg:gap-4">
            {g.items.map((it) => {
              const have = owned.has(it.code);
              return (
                <div
                  key={it.code}
                  data-testid={`unlock-${it.code}`}
                  className={`surface-soft p-4 flex flex-col items-center text-center ${have ? "" : "opacity-80"}`}
                >
                  <div className={`w-16 h-16 lg:w-20 lg:h-20 rounded-2xl flex items-center justify-center
                    ${have ? "bg-gradient-to-b from-[hsl(var(--violet-wash))] to-white shadow-[inset_0_1px_0_rgba(255,255,255,0.9),0_10px_20px_-10px_rgba(90,60,160,0.4)]"
                           : "bg-[hsl(var(--surface-2))]"}`}>
                    {have
                      ? <Check className="w-7 h-7 lg:w-9 lg:h-9 text-[hsl(var(--violet-deep))]" strokeWidth={2.4}/>
                      : <Lock className="w-5 h-5 lg:w-6 lg:h-6 text-[hsl(var(--ink-mute))]"/>}
                  </div>
                  <p className="mt-2 text-sm font-semibold text-[hsl(var(--ink))]">{it.name}</p>
                  <p className="text-[10px] uppercase tracking-widest font-semibold text-[hsl(var(--ink-mute))] mt-0.5">
                    {have ? "Unlocked" : requirementLabel(it)}
                  </p>
                </div>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}

function requirementLabel(u) {
  const base = u.type === "drums" ? "drum practices" : u.type === "english" ? "English quests" : "perfect weeks";
  return `${u.threshold} ${base}`;
}
